/**
 * API Configuration
 * Centralized configuration for API endpoints
 * 
 * Environment variables (Vite):
 * - VITE_API_BASE_URL: Override API base URL (recommended for prod builds when API is not same-origin)
 * 
 * Auto-detection:
 * - Local dev: http://localhost:8050/api
 * - *.techpuram.com → https://vaultapi.techpuram.com/api
 * - Anything else (VPS IP, custom domain): same origin + /api (nginx should proxy /api → backend)
 */

// Get API base URL from environment variable or auto-detect
export const getApiBaseUrl = () => {
	// Priority 1: Environment variable (set in .env.development or .env.production)
	if (import.meta.env.VITE_API_BASE_URL) {
		return import.meta.env.VITE_API_BASE_URL;
	}

	const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
	const isLocalDev =
		hostname === 'localhost' ||
		hostname === '127.0.0.1' ||
		hostname === '[::1]';

	if (isLocalDev) {
		return 'http://localhost:8050/api';
	}

	if (hostname === 'ivault.techpuram.com' || hostname.includes('techpuram.com')) {
		return 'https://vaultapi.techpuram.com/api';
	}

	// VPS / custom domain: avoid falling back to localhost (breaks every non-techpuram prod deploy)
	if (typeof window !== 'undefined' && window.location?.origin) {
		return `${window.location.origin}/api`;
	}

	return 'http://localhost:8050/api';
};

// Export the API base URL
export const API_BASE_URL = getApiBaseUrl();

// Helper function to build full API URL
export const getApiUrl = (path = '') => {
	const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
	const apiPath = path.startsWith('/') ? path : `/${path}`;
	return `${baseUrl}${apiPath}`;
};

